import { getStore } from '~/mobx/AppStore';

export const getIsLoading = () => {
    const { generalSettingsStore } = getStore();
    return (
        generalSettingsStore.isLoadingElectionList ||
        generalSettingsStore.isLoadingRegionData ||
        generalSettingsStore.isLoadingElectionData ||
        generalSettingsStore.isUpdatingElectionData ||
        generalSettingsStore.isUpdatingRegionData
    );
};
